// import React, { useState } from 'react';
import axios from "axios";
import AWS from "aws-sdk";
import { v4 as uuidv4 } from "uuid";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import { configure } from './../../config';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
  Box,
  Paper,
  Container,
  Grid,
  Typography,
  FormGroup,
  Divider,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import React, { useState, useEffect } from 'react';
import React, { useState } from "react";
import "./Create_user.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

export const Company_details = () => {
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [spoc_name, setSpoc_name] = useState("");
  const [phone_number, setphone_number] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [Company_Name, setCompany_Name] = useState("");
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [status, setStatus] = useState("");
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      'Content-Type': 'application/json',
      "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
      "Access-Control-Allow-Credentials": true,
      "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey"
    }
  };
  var idToken = JSON.parse(sessionStorage.getItem("accessToken"));

  const [formErrors, setFormErrors] = useState({
    email: "",
    Company_Name: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleCloseSuccessAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const postData = async() => {

    if (
      email.trim() === "" ||
      spoc_name.trim() === "" ||
      phone_number.trim() === "" ||
      Company_Name.trim() === "" ||
      status.trim()===""
    ) {
      setAlertMessage("Please fill in all required fields.");
      setOpenAlert(true);
      return;
    }

    const phoneRegex=/^[0-9\+\-()]+$/;
    // if (!phone_number.match(phoneRegex))
    if (!phoneRegex.test(phone_number))
    {
      setAlertMessage("Phone number should contain only numbers.");
      setOpenAlert(true);
      return;
    }

    if(
        Company_Name.length===0){
          setAlertMessage('Company name cannot be empty.')
            setOpenAlert(true)
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setAlertMessage("Please enter a valid email address.");
    setOpenAlert(true);
    return;
  }
     
    const data = JSON.stringify({
      SPOC_Email: email,
      SPOC_Name: spoc_name,
      Phone: phone_number,
      company_name: Company_Name,
      Status: status === "Active" ? "A" : "I",
    });
    config.headers.Authorization = "Bearer "+ idToken.jwtToken;
    const response_Company = await fetch(`${configure.backendUrl}/lfts_Company_Access`, {
      method: 'POST',
      body: data,
      headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
  });
    const response_CompanyData = await response_Company.text();
    if (response_CompanyData  && response_Company.status === 200) {
      if (response_CompanyData === "Company details added successfully") {
        setSuccessMessage(response_CompanyData);
        setOpenSuccessAlert(true);
      } else if (response_CompanyData === "Company name already exists") {
        const error0 = response_CompanyData
        console.log(error0)
        setAlertMessage(error0);
        setOpenAlert(true);
      } else {
        setAlertMessage(response_CompanyData);
        setOpenAlert(true);
      }
    }
    else {
      navigate('/login');
      setErrorMessage(
        "Failed to create company details.please check your data."
      );
      setOpenAlert(true);
    }
  };

  return (
    <div>
      <Grid
        sticky
        sx={{
          flexDirection: "column",
          marginLeft: 2,
          marginRight: 3,
          height: "85vh",
        }}
      >
        
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            marginLeft: 1,
            marginTop: 3,
          }}
        >
          <Typography fontWeight={500} fontSize={22} color="text.secondary" sx={{ marginTop: -2 , marginLeft:-1 }}>
            Company Details{" "}
          </Typography>
        </Box>

        <Box sx={{ marginTop: 0 , marginRight:1 }}>
          <Divider sx={{ bgcolor: "#bdbdbd", borderBottomWidth: 1 }} />
        </Box>
        <Grid container spacing={1} marginTop={1}>
          <Grid item xs={12} sm={12}>
            <Typography component="h6" fontSize={15}>
              Company Name *
            </Typography>
            <TextField
              autoComplete="given-name"
              type="text"
              name="Company_Name"
              value={Company_Name}
              
              required
              fullWidth
              id="Company_Name"
              
              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setCompany_Name(e.target.value.toUpperCase())}
            />

            {formErrors.Company_Name && (
              <div className="error">{formErrors.Company_Name}</div>
            )}
          </Grid>
          

          <Grid item xs={12} sm={6}>
            <Typography component="h6" fontSize={15} required>
              SPOC Name *
            </Typography>

            <TextField
              autoComplete="given-name"
              type="text"
              name="spoc_name"
              value={spoc_name}
              required
              fullWidth
              id="First Name"
              
              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setSpoc_name(e.target.value)}
            />

            
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography component="h6" fontSize={15}>
              SPOC E-Mail *
            </Typography>

            
            <TextField
              autoComplete="given-name"
              name="E-Mail"
              type="text"
              value={email}
              
              required
              fullWidth
              id="E-Mail"
              
              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />

            {formErrors.email && (
              <div className="error">{formErrors.email}</div>
            )}
          </Grid>

          <Grid item xs={12} sm={8}>
            <Typography component="h6" fontSize={15}>
              Phone Number *
            </Typography>

            <TextField
              autoComplete="given-name"
              type="text"
              name="Phone_Number"
              value={phone_number}
              
              fullWidth
              id="Password"

              autoFocus
              size="small"
              className="form-control"
              onChange={(e) => setphone_number(e.target.value)}
              

            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography component="h6" fontSize={15}>
              Status *
            </Typography>

            <FormControl fullWidth size="small">
              <Select
                
                value={status}
                
                labelId="status-label"
                id="status-select"
                
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        
           

        <Button
          onClick={postData}
          type="submit"
          halfWidth
          variant="contained"
           sx={{ mt: 4, mb: 1, marginLeft: 120, width: 50, marginTop: 18 }}
          color="success"
        >
          {" "}
          Submit{" "}
        </Button>
       
 

        
      </Grid>



      <Snackbar
  open={openAlert}
  autoHideDuration={9000}
  onClose={handleCloseAlert}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <MuiAlert
    elevation={6}
    variant="filled"
    onClose={handleCloseAlert}
    severity="error"
  >
    {alertMessage}
  </MuiAlert>
</Snackbar>
 
<Snackbar
  open={openSuccessAlert}
  autoHideDuration={9000}
  onClose={handleCloseSuccessAlert}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <MuiAlert
    elevation={6}
    variant="filled"
    onClose={handleCloseSuccessAlert}
    severity="success"
  >
    {successMessage}
  </MuiAlert>
</Snackbar>

     
    </div>
  );
};
